import './App.css';
import S1_Header from "./pages/MainPage/S1_Header";
import S2_Aboutus from "./pages/MainPage/S2_Aboutus";
import S4_Tokenomics from "./pages/MainPage/S4_Tokenomics";
import S6_Footer from "./pages/MainPage/S6_Footer";
import S7_Features from "./pages/MainPage/S7_Features";

function App() {
  return (
    <div>
      <S1_Header />
      <S2_Aboutus />
      <S7_Features />
      <S4_Tokenomics />
      <S6_Footer />
    </div>
  );
}

export default App;
